<div class="container-layout">
  <div class="remaining-space">
    <div class="header d-flex justify-content-center align-items-center navig pb-1">
      <div class="row col-md-12">
        <div class="col-md-6">
          <button
            type="button"
            class="tabBtn w-100"
            [class.active]="topTab() === 'design'"
            (click)="topTab.set('design')"
            >
            {{ 'QAQC_TAB.DESIGN_TITLE' | translate }}
          </button>
        </div>
        <div class="col-md-6">
          <button
            type="button"
            class="tabBtn w-100"
            [class.active]="topTab() === 'dashboard'"
            (click)="topTab.set('dashboard')"
            >
            {{ 'QAQC_TAB.DASHBOARD_TITLE' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div [hidden]="topTab() !== 'design'" class="h-100">
      <ng-container>

        <div>
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-6">
              <div class="form-group mb-2 input-select">
                <ng-select
                  name="selectType"
                  class="input-focus"
                  id="selectType"
                  [items]="types"
                  bindLabel="nom"
                  bindValue="id"
                  [ngModel]="selectedType()"
                  (ngModelChange)="onTypeChange($event)"
                  >
                  <ng-template ng-label-tmp let-item="item">
                    {{ 'QAQC_TAB.' + item.nom | translate }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ 'QAQC_TAB.' + item.nom | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="w-100 d-flex justify-content-center">
                @if (selectedType() === FilterType.Dates && dates().length > 0) {
                  <div class="form-group mb-0">
                    <input
                      type="checkbox"
                      id="selectAllDates"
                      [checked]="areAllSelected()"
                      [indeterminate]="dateSelected().length > 0 && !areAllSelected()"
                      (change)="onSelectAllChange($event)"
                      />
                      <label for="selectAllDates" class="ps-2 mt-3">
                        <b>{{ (areAllSelected() ? 'QAQC_TAB.DESELECT_ALL' : 'QAQC_TAB.SELECT_ALL') | translate }}</b>
                      </label>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <ng-container>
            <div [hidden]="viewTab() !== '2d'" class="container-2d w-100">
              @if (holeLayer != undefined && blast()?.BlastDesign?.length > 0) {
                <div class="mt-1">
                  @if (selectedType() === FilterType.State) {
                    <div
                      class="legend d-flex mt-0"
                      >
                      @for (group of groups; track group) {
                        <ul class="col-md-4">
                          @for (status of group; track status) {
                            <li
                              class="d-flex align-items-center gap-2"
                              >
                              <label class="radio-control">
                                <input
                                  type="radio"
                                  [id]="status"
                                  name="legend-group"
                                  [checked]="selectedHoleStatusFilter() === status"
                                  (change)="onHoleStatusFilterChange(status)"
                                  />
                                  <span class="radio-mark mb-1"></span>
                                  <label [for]="status" class="mb-0">
                                    @if (status !== 'actual') {
                                      <img
                                        [src]="getHoleStatusIcon(status)"
                                        alt="{{ status }}"
                                        class="hole-status-icon"
                                        />
                                    }
                                    {{ status === 'actual' ? ('QAQC_TAB.ACTUAL' | translate) : ('HOLE.' + status | translate) }}
                                  </label>
                                </label>
                              </li>
                            }
                          </ul>
                        }
                      </div>
                    }
                    @if (selectedType() === FilterType.Quality) {
                      <div
                        class="legend d-flex"
                        >
                        <ng-container>
                          <ul class="col-md-12 mb-2">
                            <li class="d-flex align-items-center gap-2">
                              @for (quality of qualities; track quality) {
                                <div
                                  class="col-md-4 p-0"
                                  >
                                  <div class="col-md-12 p-0">
                                    <label class="radio-control">
                                      <input
                                        type="radio"
                                        [id]="quality.key"
                                        name="qualityGroup"
                                        [value]="quality.key"
                                        [ngModel]="qualitySelected()"
                                        (ngModelChange)="onQualitySelectedChange($event)"
                                        />
                                        <span class="radio-mark"></span>
                                        <label [for]="quality.key" class="title1">
                                          <img
                                            [src]="getIconHoleQuality(quality.key)"
                                            alt="{{ quality.key }}"
                                            class="hole-status-icon"
                                            />
                                            @if (qualitySelected() === quality.key) {
                                              <b>{{
                                                'QAQC_TAB.' + quality.label | translate
                                              }}</b>
                                            }
                                            @if (qualitySelected() === quality.key) {
                                              <b class="ps-1"> ({{ quality.unit }})</b>
                                            }
                                            @if (qualitySelected() !== quality.key) {
                                              <span>{{
                                                'QAQC_TAB.' + quality.label | translate
                                              }}</span>
                                            }
                                            @if (qualitySelected() !== quality.key) {
                                              <span class="ps-1"> ({{ quality.unit }})</span>
                                            }
                                          </label>
                                        </label>
                                      </div>
                                      <div class="col-md-12 ps-27">
                                        @for (item of qualitiesColor; track item) {
                                          <div>
                                            <label>
                                              <span
                                                class="swatch title2"
                                                [ngClass]="'swatch--' + item.color"
                                              ></span>
                                              @if (qualitySelected() === quality.key) {
                                                <b class="title2"
                                                  >{{
                                                  getTextQualityType(item.type, quality.key)
                                                  }}
                                                </b>
                                              }
                                              @if (qualitySelected() !== quality.key) {
                                                <span class="title2">{{
                                                  getTextQualityType(item.type, quality.key)
                                                }}</span>
                                              }
                                            </label>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        }
                        @if (selectedType() === FilterType.Dates) {
                          <div class="legend">
                            @if (dates().length > 0) {
                              <div class="dates-container" [ngClass]="{'scrollable': dates().length > 9}">
                                @for (date of dates(); track date; let i = $index) {
                                  <div
                                    class="col-md-4 d-inline-flex p-0"
                                    >
                                    <div class="col-md-12">
                                      <input
                                        type="checkbox"
                                        class="me-2"
                                        [id]="date"
                                        [value]="date"
                                        [checked]="dateSelected().includes(date)"
                                        (change)="onCheckboxChange($event, date)"
                                        />
                                        <label [for]="date" class="ps-10">
                                          <div>
                                            <div>
                                              <span
                                                class="swatch"
                                                [style.background-color]="getDateColor(date)"
                                              ></span>
                                              @if (dateSelected().includes(date)) {
                                                <b
                                                  >{{ 'QAQC_TAB.DAY' | translate }} {{ i + 1 }}</b
                                                  >
                                              }
                                              @if (!dateSelected().includes(date)) {
                                                <span
                                                  >{{ 'QAQC_TAB.DAY' | translate }} {{ i + 1 }}</span
                                                  >
                                                }
                                              </div>
                                              <div>
                                                <span>{{ date }}</span>
                                              </div>
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (dates().length === 0) {
                                  <div>
                                    <span class="no-records text-size pb-2">
                                      {{'RECORD.NO_DATES' | translate}}
                                    </span>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }

                        <div class="map-detail-wrapper">
                          @if (isMapLoading()) {
                            <div class="map-loading-overlay">
                              <div class="spinner">
                                <div class="double-bounce1"></div>
                                <div class="double-bounce2"></div>
                              </div>
                            </div>
                          }

                          <div
                            id="map-design"
                            class="map-detail"
                            [class.map-loading]="isMapLoading()"
                            [hidden]="holeLayer == undefined || !blast()?.BlastDesign?.length"
                          ></div>
                        </div>
                      </div>
                      <div [hidden]="viewTab() !== '3d'" class="empty w-100"></div>
                    </ng-container>
                  </ng-container>
                </div>

                <div [hidden]="topTab() !== 'dashboard'">
                  <ng-container>
                    <div class="content flex-fill mx-2 mb-3 border rounded bg-white">
                      <div class="empty w-100"></div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>


